import ProductoFactura from "./FacturaPorPuntos";

export default ProductoFactura;
